<div class="scroll-top__container">
  <button
    @slide
    *ngIf="isVisible$ | async"
    class="scroll-top__button position-relative w-100 h-100"
    (click)="scrollTop()"
  >
    <mat-icon svgIcon="chevron_up"></mat-icon>
  </button>
</div>
